import React, { Component } from 'react';
import Icon from './Icon.js';
import './Svg.scss';
import './Icon.scss';

export default class AddIcon extends Component {
    render () {
        let finalClassName = Icon.buildCssClass(this.props);

        return (
            <svg class={finalClassName} width="18" height="18">
                <path fillRule="evenodd" d="M16.64 9.817H6.609l2.422 2.422a.817.817 0 1 1-1.157 1.157l-3.82-3.818a.817.817 0 0 1 0-1.158l3.82-3.817A.818.818 0 1 1 9.032 5.76L6.609 8.181H16.64a.818.818 0 1 1 0 1.636zM8.453 1.636H2.176v14.727h6.277a.819.819 0 1 1 0 1.636H1.357a.819.819 0 0 1-.819-.818V.817c0-.452.367-.818.819-.818h7.096a.819.819 0 1 1 0 1.637z"/>
            </svg>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/icon/Enter.js